import React, { useState } from 'react';
import styled from "styled-components";
import Picker from "emoji-picker-react";
import {IoMdSend} from 'react-icons/io'
import {BsEmojiSmileFill} from 'react-icons/bs'

const ChatInput = ({handleSendMsg}) => {
    const [showEmojiPicker,setShowEmojiPicker] = useState(false);
    const [msg,setMsg] = useState("");

    const handleEmojiPickerHideShow = ()=>{
        setShowEmojiPicker(!showEmojiPicker);
    }

    const handleEmojiClick = (event,emoji)=>{
        let message = msg;
        message += emoji.emoji;
        setMsg(message);
    }

    const sendChat = (event)=>{
        event.preventDefault();
        if(msg.length>0){
            handleSendMsg(msg);
            setMsg("");
        }
    }

  return (
    <Container>
      <div className="button-container">
        <div className="emoji">
            <BsEmojiSmileFill onClick={handleEmojiPickerHideShow}/>
            {
                showEmojiPicker && <Picker onEmojiClick={handleEmojiClick}/>}
        </div>
      </div>
      <form className="input-container" onSubmit={(e)=>sendChat(e)}>
        <input type="text" placeholder='Type your message here' value={msg} onChange={(e)=>setMsg(e.target.value)} />
        <button className="submit">
            <IoMdSend/>
        </button>
      </form>
    </Container>
  )
}

const Container = styled.div`
    display: grid;
    grid-template-columns: 5% 95%;
    align-items: center;
    background-color: #080420;
    padding: 0 2rem;
    padding-bottom: 0.3rem;
    @media screen and (min-width: 720px) and (max-width: 1080px) {
        padding: 0 1rem;
        gap: 1rem;
    }
    @media screen and (min-width: 420px) and (max-width: 720px) {
        padding: 0 8px;
        grid-template-columns: 6% 88%;
        gap: 1rem;
    }
    @media screen and (min-width: 320px) and (max-width: 420px) {
        padding: 0px 0px;
        padding-bottom: 0px;
        grid-template-columns: 13% 87%;
        gap: 0.2rem;
    }
    .button-container{
        display: flex;
        align-items: center;
        color: white;
        gap: 1rem;
        .emoji{
            position: relative;
            svg{
                font-size: 1.5rem;
                color: #ffff00c8;
                cursor: pointer;
                @media screen and (min-width: 420px) and (max-width: 720px) {
                font-size: 1.3rem;
    }
            }
            .emoji-picker-react{
                position: absolute;
                top : -350px;
                background-color:#080420;
                box-shadow: 0 5px 10px #9a86f3;
                border-color: #9a86f3;
                .emoji-scroll-wrapper::-webkit-scrollbar{
                    background-color: #080420;
                    width: 5px;
                    &-thumb{
                        background-color: #9a86f3
                    }
                }
                .emoji-categories{
                    button{
                        filter: contrast(0);
                    }
                }
                .emoji-search{
                    background-color: transparent;
                    border-color: #9186f3;
                    color: white;
                }
                .emoji-group:before{
                    background-color: #080420;
                }
            }
        }
    }
    .input-container{
        width: 100%;
        display: flex;
        align-items: center;
        gap: 2rem;
        border-radius: 2rem;
        background-color: #ffffff34;
        input{
            width: 90%;
            height: 60%;
            background-color: transparent;
            color: white;
            padding-left: 1rem;
            font-size: 1.2rem;
            border: none;
            &::selection{
                background-color: #9a86f3;
            }
            &:focus {
                outline: none;
            }
        }
        button{
            padding: 0.3rem 2rem;
            border-radius: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #9a86f3;
            border: none;
            @media screen and (min-width: 720px) and (max-width: 1080px) {
                padding: 0.3rem 1rem;
                svg{
                    font-size: 1rem;
                }
            }
            @media screen and (min-width: 420px) and (max-width: 720px) {
                padding: 6px 10px;
                svg{
                    font-size: 22px;
                }
    }
    @media screen and (min-width: 320px) and (max-width: 420px) {
        padding: 2px 9px;
                svg{
                    font-size: 20px;
                }
        }
            svg{
                font-size: 2rem;
                color: white;
            }
        }

        @media screen and (min-width: 320px) and (max-width: 420px) {
            gap: 0px;
            width: 85%;
        }
        
    }
`;

export default ChatInput
